// extracted by mini-css-extract-plugin
export var comment = "Comment-module--comment--TzRoh";
export var header = "Comment-module--header--2D3T3";
export var anchor = "Comment-module--anchor--1zlqP";
export var meta = "Comment-module--meta--fawk4";
export var avatar = "Comment-module--avatar--xfNgm";
export var name = "Comment-module--name--2TIAj";
export var date = "Comment-module--date--g_gEp";
export var replyBtn = "Comment-module--reply-btn--3qKSe";
export var replyBtnText = "Comment-module--reply-btn-text--Fak-0";